<template>
  <div class="GenerateDoc">
    <create-message v-if="isMessage" />
    <show-document v-if="!isMessage && isHowDoc" :item="form" />
    <form v-else-if="!isMessage" action="" class="gen-form gen-doc-form">
      <div class="gen-fieldset__item">
        <label>Title</label>
        <input v-model="form.title" type="text">
      </div>
      <div class="gen-fieldset__item">
        <div class="gen-select-container ">
          <label>Format</label>
          <div class="ui-ddbox ui-ddbox-select">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue">
                {{ form.type }}
              </span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection ui-assignedtoList">
                <ul>
                  <li @click="changeFormat('PDF')">PDF</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <div class="gen-select-container ">
          <label>Background img</label>
          <div class="ui-ddbox ui-ddbox-select">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue">
                {{ form.background }}
              </span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection ui-assignedtoList">
                <ul>
                  <li @click="changeBackground(form.background)">
                    {{ form.background }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <div class="gen-select-container">
          <label>Text preset</label>
          <div class="ui-ddbox ui-ddbox-select">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue">
                {{ form.preset }}
              </span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection ui-assignedtoList">
                <ul>
                  <li v-for="(item, index) in docTexts" :key="index">
                    <span @click="changePreset(item)">{{ item.title }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item full-input">
        <label>Notes</label>
        <input v-model="form.comments" type="text">
      </div>
      <div class="full-input drop-block">
        <ckeditor :editor="editor" v-model="form.body"></ckeditor>
        <div ref="tagsDropdown" class="drop-wrapper">
          <a @click="isShowTags = !isShowTags" class="drop-btn">Tags
            <img src="/img/drop-down.png" alt="">
          </a>
          <ul v-if="isShowTags" class="drop-down">
            <li v-for="(tag, index) in tags" :key="index" class="drop-title">
              <span>{{ tag.name }}</span>
              <ul v-if="tag.items.length">
                <li v-for="(item, index) in tag.items" :key="index">
                  <span @click="setEditorTag(item)">{{ item.label }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="button-holder">
        <button class="btn" @click.prevent="save()">Save</button>
      </div>
    </form>
    <span class="error" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
import CreateMessage from "../document/CreateMessage";
import DocumentService from '../../../../services/document.service';
import ShowDocument from "../document/ShowDocument";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: "GenerateDoc",
  components: {ShowDocument, CreateMessage},
  data() {
    return {
      editor: ClassicEditor,
      file: '',
      error: '',
      isHowDoc: false,
      isShowTags: false,
      isMessage: false,
      tags: [],
      docTexts: [],
      form: {
        action: 'adddocument',
        title: '',
        login: '',
        comments: '',
        body: '',
        background: 'Special trade certificate fxbullion',
        preset: 'Choose preset',
        type: 'PDF',
        programid: '',
      }
    }
  },
  computed: {
    isShowNavigate: {
      get() {
        return this.$store.state.isShowNavigate;
      },
      set(value) {
        this.$store.commit('setter', {isShowNavigate: value})
      }
    },
    currentProgram() {
      return this.$store.state.currentProgram;
    },
    Lead: {
      get() {
        return this.$store.state.leadData;
      },
      set(value) {
        this.$store.commit('setter', {leadData: value})
      }
    }
  },
  mounted() {
    this.getTags();
    document.addEventListener('click', this.hideTags);
    this.form.title = this.form.action + ' ' + this.currentProgram.asset + ' ' + this.currentProgram.id;
  },
  methods: {
    hideTags(e) {
      if (this.$refs.tagsDropdown && !this.$refs.tagsDropdown.contains(e.target)) {
        this.isShowTags = false
      }
    },
    setEditorTag(tag) {
      const shortcode = `[${tag.key}]`;
      this.form.body = this.form.body + '' + shortcode;
    },
    getTags() {
      const query = {
        action: 'ini',
        type: 'program'
      }

      DocumentService.execute(query).then((res) => {
        this.tags = res.data.tags;
        this.docTexts = res.data.doctexts;
      }).catch((error) => {
        this.error = error.response.message;
      })
    },
    changeBackground(value) {
      this.form.background = value;
    },
    changePreset(value) {
      this.form.preset = value.type;
      this.form.body = value.body;
    },
    changeFormat(value) {
      this.form.type = value;
    },
    save() {
      this.isMessage = true;
      this.isHowDoc = false;
      this.form.login = this.Lead.info.login;
      this.form.programid = this.currentProgram.id;

      DocumentService.execute(this.form).then((res) => {
        this.isMessage = false;
        this.isShowNavigate = false;
        this.isHowDoc = true;
        this.form = res.data.data;
      }).catch((error) => {
        this.isMessage = false;
        this.error = error.response.message;
      })
    }
  }
}
</script>

<style lang="scss">
.GenerateDoc {
  .error {
    color: #b20a0a;
  }
}

.SpTradesTab {
  .gen-doc-form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-top: 41px;

    label {
      margin-bottom: 7px;
    }

    .gen-fieldset__item {
      margin-bottom: 20px;
    }

    .button-holder {
      width: 100%;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
    }

    .ck {
      &.ck-editor__editable {
        transition: all 0.3s;

        &:not(.ck-editor__nested-editable) {
          &.ck-focused {
            border-color: #b2e3ff !important;
            box-shadow: none !important;
          }
        }
      }

      &.ck-toolbar {
        border-color: #b2e3ff !important;
      }

      &.ck-editor__main {
        > .ck-editor__editable {
          height: 340px;

          &:not(.ck-focused) {
            border-color: #b2e3ff !important;
            box-shadow: none !important;

            &:focus {
              border-color: #b2e3ff;
            }
          }
        }
      }
    }
  }

  .full-input {
    position: relative;
    width: 100%;
    margin-bottom: 20px;

    &.drop-block {
      margin-top: 37px;
    }
  }
}

.drop-wrapper {
  display: inline-block;
  position: absolute;
  top: -43px;
  right: 0;

  .drop-btn {
    min-width: 117px;
    display: inline-block;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    position: relative;
    padding: 6px 10px;
    background: linear-gradient(180deg, #ffff 0%, #e9e9e9 100%);
    border: 1px solid #cbcbcb;
    outline: none;
    border-radius: 3px;
    text-decoration: none;

    img {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 99;

    li {
      font-size: 12px;
      font-weight: 400;
      color: #585858;
      cursor: pointer;
    }
  }

  .drop-down {
    position: absolute;
    top: 100%;
    background: #ffff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 3px 3px;
    width: 100%;
    padding: 4px 9px;
    max-height: 185px;
    overflow-y: scroll;

    .drop-title {
      span {
        font-size: 14px;
        font-weight: 600;
      }

      ul {
        padding: 9px 0 0 6px;

        li {
          margin-bottom: 7px;
        }
      }
    }
  }
}
</style>
